

import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from '../../apiService/allApi';
// import "./LoginUI.css"; // Ensure you create this CSS file

export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { referralcode } = useParams();

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [isValid, setIsValid] = useState(false);
  const [seconds, setSeconds] = useState(60);

  const referral = referralcode || location.pathname.split("/")[2] || "";

  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      clearInterval(timerInterval);
      setIsValid(false);
    }
    return () => clearInterval(timerInterval);
  }, [isValid, seconds]);

  // const handleClick = async (e) => {
  //   if (e) e.preventDefault();
  //   if (!Phone || Phone.length !== 10) {
  //     return Swal.fire({ icon: "error", title: "Oops...", text: "Please enter correct phone number" });
  //   }
  //   setIsloading1(true);
  //   const respone = await apiRequest('login', "POST", { Phone, referral });
  //   setIsloading1(false);
  //   if (respone?.data?.status === 200) {
  //     setOtp(true);
  //     setIsValid(true);
  //     setSeconds(60);
  //     setSecretCode(respone?.data?.secret);
  //     if (respone?.data?.myToken) {
  //       Swal.fire({ icon: "success", title: "OTP", text: "Demo OTP: " + respone?.data?.myToken });
  //     }
  //   } else {
  //     Swal.fire({ icon: "error", title: "Oops...", text: respone?.data?.msg || "Login failed" });
  //   }
  // };


  const handleClick = async (e) => {
  if (e) e.preventDefault();

  if (!Phone || Phone.length !== 10) {
    return Swal.fire({
      icon: "error",
      title: "Invalid Mobile Number",
      text: "Please enter a correct 10-digit phone number.",
      confirmButtonText: "OK",
    });
  }

  if (isLoading1) return;

  setIsloading1(true);

  try {
    const response = await apiRequest("login", "POST", {
      Phone,
      referral,
    });

    const data = response?.data;

    if (data?.status === 200) {
      setOtp(true);
      setIsValid(true);
      setSeconds(60);
      setSecretCode(data?.secret);
      settwofactor_code("");

      if (data?.myToken) {
        await Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: "Demo OTP: " + data.myToken,
          confirmButtonText: "OK",
        });
      } else {
        await Swal.fire({
          icon: "success",
          title: "OTP Sent Successfully",
          text: "Please check your mobile for the OTP.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } else {
      const statusCode = response?.status || data?.statusCode || data?.status;

      await Swal.fire({
        icon: "error",
        title: statusCode === 429 ? "Please Wait" : "OTP Failed",
        text:
          data?.msg ||
          data?.message ||
          (statusCode === 429
            ? "Too many OTP requests. Please wait before trying again."
            : "Unable to send OTP. Please try again."),
        confirmButtonText: "OK",
      });
    }
  } catch (error) {
    const statusCode = error?.response?.status;
    const data = error?.response?.data;

    Swal.fire({
      icon: "error",
      title: statusCode === 429 ? "OTP Limit Reached" : "Request Failed",
      text:
        data?.msg ||
        data?.message ||
        (statusCode === 429
          ? "OTP already requested. Please wait 60 seconds before trying again."
          : "Something went wrong. Please check your internet connection and try again."),
      confirmButtonText: "OK",
    });
  } finally {
    setIsloading1(false);
  }
};
  const varifyOtp = async (e) => {
    e.preventDefault();
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode });
      setIsloading1(false);
      if (response?.data?.status === 200) {
        localStorage.setItem("token", response?.data?.token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({ icon: "error", title: "Oops...", text: response?.data?.msg || "Something went wrong!" });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({ icon: "error", title: "Oops...", text: "Error verifying OTP" });
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-header-text">
        <h1>Welcome <span>Back</span></h1>
        <h2>apnaone!</h2>
        <p>Log in, gear up, and dominate the game!</p>
      </div>

      <div className="login-card">
        <div className="card-gradient-header">
          <h3>Login to your Account</h3>
        </div>

        <div className="card-body">
          <form onSubmit={otp ? varifyOtp : handleClick}>
            <div className="input-label">Enter Mobile Number</div>
            
            <div className="phone-input-group">
              <div className="country-code">+91</div>
              <input
                type="tel"
                placeholder="Mobile number"
                value={Phone}
                disabled={otp}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                required
              />
            </div>

            {otp && (
              <div className="input-section-otp">
                <div className="input-label" style={{ marginTop: '15px' }}>Enter OTP</div>
                <input
                  type="text"
                  className="otp-single-input"
                  placeholder="000000"
                  onChange={(e) => settwofactor_code(e.target.value)}
                  required
                />
                <div className="resend-timer-box">
                  {seconds > 0 ? (
                    `Resend in ${seconds}s`
                  ) : (
                    <span className="resend-link" onClick={handleClick}>Resend OTP</span>
                  )}
                </div>
              </div>
            )}

            <button type="submit" className="submit-btn" disabled={isLoading1}>
              {isLoading1 ? <Spinner animation="border" size="sm" /> : (otp ? "Verify OTP" : "Send OTP")}
            </button>
          </form>
        </div>
      </div>

      <div className="terms-footer">
        By logging in, you agree to our <strong>Terms & Conditions</strong>
      </div>
    </div>
  );
}